import './sass/App.scss'
//import { HelmetProvider } from 'react-helmet-async'

import { BUILD_PROFILE } from './costants'

import BicyclePage from './page/bicycle/BicyclePage'
import CommercialPage from './page/commercial/CommercialPage'
import CyberPage from './page/cyber/CyberPage'
import FirePage from './page/fire/FirePage'
import HealthPage from './page/health/HealthPage'
import HomePage from './page/home/HomePage'
import HouseholderPage from './page/householder/HouseholderPage'
import InjuryPage from './page/injury/InjuryPage'
import MicroCarPage from './page/microcar/MicroCarPage'
import LifePage from './page/life/LifePage' 
import PetPage from './page/pets/PetPage'
import ProfessionalPage from './page/professional/ProfessionalPage'
import ShipPage from './page/ship/ShipPage'
import SmartPhonePage from './page/smartphone/SmartPhonePage'
import TravelPage from './page/travel/TravelPage'
import VintageBikePage from './page/vintagebike/VintageBikePage'
import VintageCarPage from './page/vintagecar/VintageCarPage'

function App() {

  return (
    <>
      {BUILD_PROFILE === 'BICYCLE' &&
        <BicyclePage />
      }
      {BUILD_PROFILE === 'COMMERCIAL_VEHICLE' &&
        <CommercialPage />
      }
      {BUILD_PROFILE === 'CYBER' &&
        <CyberPage />
      }
      {BUILD_PROFILE === 'FIRE' &&
        <FirePage />
      }
      {BUILD_PROFILE === 'LIFE' &&
        <LifePage />
      }
      {BUILD_PROFILE === 'HEALTH' &&
        <HealthPage />
      }
      {BUILD_PROFILE === 'HOME' &&
        <HomePage />
      }
      {BUILD_PROFILE === 'HOUSEHOLDER' &&
        <HouseholderPage />
      }
      {BUILD_PROFILE === 'INJURY' &&
        <InjuryPage />
      }
      {BUILD_PROFILE === 'MICROCAR' &&
        <MicroCarPage />
      }
      {BUILD_PROFILE === 'PETS' && 
        <PetPage />
      }
      {BUILD_PROFILE === 'PROFESSIONAL' && 
        <ProfessionalPage />
      }
      {BUILD_PROFILE === 'SHIP' &&
        <ShipPage />
      }
      {BUILD_PROFILE === 'SMART_PHONE' &&
        <SmartPhonePage />
      }
      {BUILD_PROFILE === 'TRAVEL' &&
        <TravelPage />
      }
      {BUILD_PROFILE === 'VINTAGEBIKE' &&
        <VintageBikePage />
      }
      {BUILD_PROFILE === 'VINTAGECAR' &&
        <VintageCarPage />
      }
    </>
  )

}

export default App
